/** Joins class names, skipping falsy entries (CSS Module lookups may be undefined). */
export function cx(...names: ReadonlyArray<string | false | null | undefined>): string {
  let out = '';
  for (const n of names) {
    if (typeof n === 'string' && n !== '') out = out === '' ? n : `${out} ${n}`;
  }
  return out;
}
